<template>
  <WebsiteLayout>
    <div class="app-container hero ">
      <div class="main-app-wrapper dashboard ">
        <div class="div-block-56">
          <div class="div-block-57">
            <div class="text-block-49">Discover</div>
            <div class="text-block-50">
              Explore and discover professionals  of your choice and available
              group classes
            </div>
          </div>
          <div
            data-current="Tab 2"
            data-easing="ease"
            data-duration-in="300"
            data-duration-out="100"
            class="tabs-3 w-tabs"
          >
            <div class="tabs-menu-5 w-tab-menu">
              <a
                @click="openProfessionals"
                data-w-tab="Tab 1"
                :class="
                  isProfessionalsOpen
                    ? 'booking-tab w-inline-block w-tab-link w--current'
                    : 'booking-tab w-inline-block w-tab-link'
                "
              >
                <div>Professionals</div>
              </a>
              <a
                @click="openClassesDiscover"
                data-w-tab="Tab 2"
                :class="
                  isClassesOpen
                    ? 'booking-tab w-inline-block w-tab-link w--current'
                    : 'booking-tab w-inline-block w-tab-link'
                "
              >
                <div>Classes</div>
              </a>
            </div>
            <div class="w-tab-content">
              <div
                data-w-tab="Tab 1"
                :class="
                  isProfessionalsOpen
                    ? 'w-tab-pane w--tab-active'
                    : 'w-tab-pane'
                "
              >
                <!--              <div class="filter-wrapper">-->
                <!--                <div class="div-block-166">-->
                <!--                  <form action="/search" class="search-3 w-form">-->
                <!--                    <input type="search" class="search-input-4 w-input" maxlength="256" name="query" placeholder="Search…" id="search-2" required=""><input type="submit" value="Search" class="search-button-3 w-button">-->
                <!--                  </form>-->
                <!--                </div>-->
                <!--                <div class="div-block-58">-->
                <!--                  <div data-delay="0" data-hover="false" class="dropdown-2 w-dropdown">-->
                <!--                    <div class="w-dropdown-toggle">-->
                <!--                      <div class="w-icon-dropdown-toggle"></div>-->
                <!--                      <div class="text-block-51">Expertise</div>-->
                <!--                    </div>-->
                <!--                    <nav class="dropdown_timeslot w-dropdown-list">-->
                <!--                      <a href="#" class="filter-link w-dropdown-link">All</a>-->
                <!--                      <a href="#" class="filter-link w-dropdown-link">Design</a>-->
                <!--                      <a href="#" class="filter-link w-dropdown-link">Healthcare</a>-->
                <!--                      <a href="#" class="filter-link w-dropdown-link">Leadership</a>-->
                <!--                      <a href="#" class="filter-link w-dropdown-link">Marketing</a>-->
                <!--                      <a href="#" class="filter-link w-dropdown-link">Product Management</a>-->
                <!--                      <a href="#" class="filter-link w-dropdown-link">Product Research</a>-->
                <!--                      <a href="#" class="filter-link w-dropdown-link">Technology</a>-->
                <!--                    </nav>-->
                <!--                  </div>-->
                <!--                  <div data-delay="0" data-hover="false" class="dropdown-2 w-dropdown">-->
                <!--                    <div class="w-dropdown-toggle">-->
                <!--                      <div class="w-icon-dropdown-toggle"></div>-->
                <!--                      <div class="text-block-52">Level</div>-->
                <!--                    </div>-->
                <!--                    <nav class="dropdown_timeslot w-dropdown-list">-->
                <!--                      <a href="#" class="w-dropdown-link">All</a>-->
                <!--                      <a href="#" class="w-dropdown-link">Entry Level</a>-->
                <!--                      <a href="#" class="w-dropdown-link">Intermediate</a>-->
                <!--                      <a href="#" class="w-dropdown-link">Manager</a>-->
                <!--                      <a href="#" class="w-dropdown-link">Director</a>-->
                <!--                      <a href="#" class="w-dropdown-link">Lead</a>-->
                <!--                      <a href="#" class="w-dropdown-link">Executive</a>-->
                <!--                      <a href="#" class="w-dropdown-link">Founder</a>-->
                <!--                    </nav>-->
                <!--                  </div>-->
                <!--                  <div data-delay="0" data-hover="false" class="dropdown-2 w-dropdown">-->
                <!--                    <div class="w-dropdown-toggle">-->
                <!--                      <div class="w-icon-dropdown-toggle"></div>-->
                <!--                      <div class="text-block-51">Country</div>-->
                <!--                    </div>-->
                <!--                    <nav class="dropdown_timeslot w-dropdown-list">-->
                <!--                      <a href="#" class="w-dropdown-link">Link 1</a>-->
                <!--                      <a href="#" class="w-dropdown-link">Link 2</a>-->
                <!--                      <a href="#" class="w-dropdown-link">Link 3</a>-->
                <!--                    </nav>-->
                <!--                  </div>-->
                <!--                </div>-->
                <!--                <a data-w-id="0df97a0a-0f22-d55d-d69a-dd28b90db9c5" href="#" class="button-19 w-button">Filter</a>-->
                <!--              </div>-->
                <!--              <div class="div-block-59">-->
                <!--                <div id="w-node-_5ae59988-b252-43c7-257a-66703dd36a96-8f09cdd5" class="professional-card-wrapper">-->
                <!--                  <a href="../customer/professional-profile.html" class="professional_cards w-inline-block">-->
                <!--                    <div class="div-block-177"><img loading="lazy" src="@/assets/timeslot-images/Female.png" alt="" class="image-41">-->
                <!--                      <div class="div-block-16-copy">-->
                <!--                        <div class="text-block-16">Idris Yusuf 🇬🇧</div>-->
                <!--                        <div class="text-block-17">Design &amp; Innovation Strategist</div>-->
                <!--                      </div>-->
                <!--                    </div>-->
                <!--                  </a>-->
                <!--                  <div class="div-block-199">-->
                <!--                    <div class="text-block-108">⚡Free</div>-->
                <!--                  </div>-->
                <!--                </div>-->
                <!--                <div id="w-node-c701fd21-a129-f18c-a125-a8a4047ea5c2-8f09cdd5" class="professional-card-wrapper">-->
                <!--                  <a href="../customer/professional-profile.html" class="professional_cards w-inline-block">-->
                <!--                    <div class="div-block-177"><img loading="lazy" src="@/assets/timeslot-images/Female.png" alt="" class="image-41">-->
                <!--                      <div class="div-block-16-copy">-->
                <!--                        <div class="text-block-16">Idris Yusuf 🇬🇧</div>-->
                <!--                        <div class="text-block-17">Design &amp; Innovation Strategist</div>-->
                <!--                      </div>-->
                <!--                    </div>-->
                <!--                  </a>-->
                <!--                </div>-->
                <!--                <div id="w-node-c2208174-a8c5-0227-5dd3-db4f9f57d85e-8f09cdd5" class="professional-card-wrapper">-->
                <!--                  <a href="../customer/professional-profile.html" class="professional_cards w-inline-block">-->
                <!--                    <div class="div-block-177"><img loading="lazy" src="@/assets/timeslot-images/Female.png" alt="" class="image-41">-->
                <!--                      <div class="div-block-16-copy">-->
                <!--                        <div class="text-block-16">Idris Yusuf 🇬🇧</div>-->
                <!--                        <div class="text-block-17">Design &amp; Innovation Strategist</div>-->
                <!--                      </div>-->
                <!--                    </div>-->
                <!--                  </a>-->
                <!--                  <div class="div-block-199">-->
                <!--                    <div class="text-block-108">⚡Free</div>-->
                <!--                  </div>-->
                <!--                </div>-->
                <!--                <div id="w-node-_2537dae1-61aa-8dda-2687-cad98245613e-8f09cdd5" class="professional-card-wrapper">-->
                <!--                  <a href="../customer/professional-profile.html" class="professional_cards w-inline-block">-->
                <!--                    <div class="div-block-177"><img loading="lazy" src="@/assets/timeslot-images/Female.png" alt="" class="image-41">-->
                <!--                      <div class="div-block-16-copy">-->
                <!--                        <div class="text-block-16">Idris Yusuf 🇬🇧</div>-->
                <!--                        <div class="text-block-17">Design &amp; Innovation Strategist</div>-->
                <!--                      </div>-->
                <!--                    </div>-->
                <!--                  </a>-->
                <!--                </div>-->
                <!--                <div id="w-node-db9c54a6-92ee-4e08-f711-94815a4d145b-8f09cdd5" class="professional-card-wrapper">-->
                <!--                  <a href="../customer/professional-profile.html" class="professional_cards w-inline-block">-->
                <!--                    <div class="div-block-177"><img loading="lazy" src="@/assets/timeslot-images/Female.png" alt="" class="image-41">-->
                <!--                      <div class="div-block-16-copy">-->
                <!--                        <div class="text-block-16">Idris Yusuf 🇬🇧</div>-->
                <!--                        <div class="text-block-17">Design &amp; Innovation Strategist</div>-->
                <!--                      </div>-->
                <!--                    </div>-->
                <!--                  </a>-->
                <!--                  <div class="div-block-199">-->
                <!--                    <div class="text-block-108">⚡Free</div>-->
                <!--                  </div>-->
                <!--                </div>-->
                <!--                <div id="w-node-_24f75b90-a575-6e53-f6c7-c10a45e27958-8f09cdd5" class="professional-card-wrapper">-->
                <!--                  <a href="../customer/professional-profile.html" class="professional_cards w-inline-block">-->
                <!--                    <div class="div-block-177"><img loading="lazy" src="@/assets/timeslot-images/Female.png" alt="" class="image-41">-->
                <!--                      <div class="div-block-16-copy">-->
                <!--                        <div class="text-block-16">Idris Yusuf 🇬🇧</div>-->
                <!--                        <div class="text-block-17">Design &amp; Innovation Strategist</div>-->
                <!--                      </div>-->
                <!--                    </div>-->
                <!--                  </a>-->
                <!--                  <div class="div-block-199">-->
                <!--                    <div class="text-block-108">⚡Free</div>-->
                <!--                  </div>-->
                <!--                </div>-->
                <!--                <div id="w-node-_405accf5-0e48-ff12-4785-db7dfa992612-8f09cdd5" class="professional-card-wrapper">-->
                <!--                  <a href="../customer/professional-profile.html" class="professional_cards w-inline-block">-->
                <!--                    <div class="div-block-177"><img loading="lazy" src="@/assets/timeslot-images/Female.png" alt="" class="image-41">-->
                <!--                      <div class="div-block-16-copy">-->
                <!--                        <div class="text-block-16">Idris Yusuf 🇬🇧</div>-->
                <!--                        <div class="text-block-17">Design &amp; Innovation Strategist</div>-->
                <!--                      </div>-->
                <!--                    </div>-->
                <!--                  </a>-->
                <!--                </div>-->
                <!--                <div id="w-node-ea392a9d-93bb-e43b-4480-a39d44af5068-8f09cdd5" class="professional-card-wrapper">-->
                <!--                  <a href="../customer/professional-profile.html" class="professional_cards w-inline-block">-->
                <!--                    <div class="div-block-177"><img loading="lazy" src="@/assets/timeslot-images/Female.png" alt="" class="image-41">-->
                <!--                      <div class="div-block-16-copy">-->
                <!--                        <div class="text-block-16">Idris Yusuf 🇬🇧</div>-->
                <!--                        <div class="text-block-17">Design &amp; Innovation Strategist</div>-->
                <!--                      </div>-->
                <!--                    </div>-->
                <!--                  </a>-->
                <!--                  <div class="div-block-199">-->
                <!--                    <div class="text-block-108">⚡Free</div>-->
                <!--                  </div>-->
                <!--                </div>-->
                <!--              </div>-->
                <div class="filter-wrapper">
                  <div class="div-block-166">
                    <form action="/search" class="search-3 w-form">
                      <input
                        type="search"
                        class="search-input-4 w-input"
                        maxlength="256"
                        name="query"
                        placeholder="Search…"
                        id="search-2"
                        v-model="searchModel.stringToFind"
                        @input="searchProfessionalAction"
                      />
                      <input
                        type="submit"
                        value="Search"
                        class="search-button-3 w-button"
                      />
                    </form>
                  </div>
                  <div class="div-block-58">
                    <div class="s-width">
                      <FormulateInput
                        type="select"
                        name="professionalCategory"
                        placeholder="Expertise"
                        :options="categoryList"
                        input-class="select-field"
                        v-model="searchModel.expertise"
                        @input="searchProfessionalAction"
                      />
                    </div>

                    <div class="s-width">
                      <FormulateInput
                        type="select"
                        name="professionalExperienceLevel"
                        :options="experienceLevels"
                        input-class="select-field"
                        placeholder="Level"
                        v-model="searchModel.level"
                        @input="searchProfessionalAction"
                      />
                    </div>

                    <div class="s-width">
                      <FormulateInput
                        type="select"
                        name="country"
                        validation-name="Country"
                        placeholder="Country"
                        :options="countries"
                        v-model="searchModel.country"
                        @input="searchProfessionalAction"
                      />
                    </div>
                  </div>
                </div>
                <!--              <BaseComponentLoader-->
                <!--                  v-if="loader.nonBlockingLoader"-->
                <!--                  loaderAlignment="center"-->
                <!--              />-->
                <div class="div-block-59" v-if="loader.nonBlockingLoader">
                  <div
                    class="ejzqWn skeleton-load"
                    v-for="(item, index) in listForLoader"
                    :key="index"
                  >
                    <!--                  <img-->
                    <!--                      class="ejzqWn"-->
                    <!--                      src=""-->
                    <!--                  />-->
                    <div class="overlay">
                      <div class="details">
                        <p class=" text-block-16"></p>
                        <div class="details__items">
                          <div class=" text-block-17">
                            <span></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--                  <div-->
                    <!--                      class="div-block-199"-->

                    <!--                  >-->
                    <!--                    <div class="text-block-108"></div>-->
                    <!--                  </div>-->
                  </div>
                </div>

                <div
                  class="div-block-59"
                  v-if="
                    professionalDiscover.length > 0 && !loader.nonBlockingLoader
                  "
                >
                  <!--            <div-->
                  <!--              id="w-node-_5ae59988-b252-43c7-257a-66703dd36a96-8f09cdd5"-->
                  <!--              class="professional-card-wrapper"-->
                  <!--              v-for="(professional, index) in professionalDiscover"-->
                  <!--              :key="index"-->
                  <!--            >-->
                  <!--              <a-->
                  <!--                @click="profile(professional)"-->
                  <!--                class="professional_cards w-inline-block"-->
                  <!--              >-->
                  <!--                <div class="div-block-16">-->
                  <!--                  <div class="text-block-16">-->
                  <!--                    {{ professional.customerName }}-->
                  <!--                  </div>-->
                  <!--                  <div class="text-block-17">-->
                  <!--                    {{ professional.professionalSubCategory }}-->
                  <!--                  </div>-->
                  <!--                </div>-->
                  <!--              </a>-->
                  <!--              <a href="" class="link-block-2 w-inline-block"></a>-->
                  <!--            </div>-->

                  <div
                    class="ejzqWn"
                    v-for="(professional, index) in professionalDiscover"
                    :key="index"
                    @click="profile(professional)"
                  >
                    <img
                      style="object-fit: cover;"
                      class="ejzqWn"
                      :src="
                        professional.customerDisplayPicture ||
                          'https://apvertise-repo.s3.amazonaws.com/logo23470493927891664919183983.jpeg'
                      "
                    />
                    <div class="overlay">
                      <div class="details">
                        <p class=" text-block-16">
                          {{ professional.customerName }}
                        </p>
                        <div class="details__items">
                          <div class=" text-block-17">
                            <span>{{
                              professional.professionalSubCategory
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="div-block-199"
                      v-if="professional.professionalBookingFee === 0"
                    >
                      <div class="text-block-108">⚡Free</div>
                    </div>
                  </div>
                </div>
                <div
                  class="prof-empty"
                  v-if="
                    professionalDiscover.length === 0 &&
                      !loader.nonBlockingLoader
                  "
                >
                  There are no professionals under this category
                </div>
                <div
                  class="div-block-60"
                  v-if="showMoreProfValue && !loader.nonBlockingLoader"
                >
                  <div class="button-13 w-button" @click="moreProfessionals">
                    Load more professionals
                  </div>
                </div>
              </div>
              <div
                data-w-tab="Tab 2"
                :class="
                  isClassesOpen ? 'w-tab-pane w--tab-active' : 'w-tab-pane'
                "
              >
                <div class="class-card-block" v-if="loader.nonBlockingLoader">
                  <!--                  <div-->
                  <!--                    class="w-layout-grid class-card skeleton-load"-->
                  <!--                    v-for="(item, index) in listForLoader"-->
                  <!--                    :key="index"-->
                  <!--                  >-->
                  <!--                    <div-->
                  <!--                      id="w-node-_9ade9d8b-dee7-65d3-7682-169b0d1f7ae5-8f09cdd5"-->
                  <!--                      class="card-image-block"-->
                  <!--                    >-->
                  <!--                      <div>-->
                  <!--                        <div class="text-block-112"></div>-->
                  <!--                        <div class="card-header-class"></div>-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                  <!--                    <div-->
                  <!--                      id="w-node-_9ade9d8b-dee7-65d3-7682-169b0d1f7aeb-8f09cdd5"-->
                  <!--                      class="content"-->
                  <!--                    >-->
                  <!--                      <div class="card-content-header">-->
                  <!--                        <div class="date-block" style="padding-right:0;">-->
                  <!--                          <div class="class_title"></div>-->
                  <!--                        </div>-->
                  <!--                        <div class="div-block-247">-->
                  <!--                          <div class="attendance_count"></div>-->
                  <!--                        </div>-->
                  <!--                      </div>-->
                  <!--                      <div class="prof-content">-->
                  <!--                        <div class="prof-image-block">-->
                  <!--                          &lt;!&ndash;                        <img width="55" loading="lazy" :src="" alt="">&ndash;&gt;-->
                  <!--                        </div>-->
                  <!--                        <div>-->
                  <!--                          <div class="prof-name"></div>-->
                  <!--                          <div class="prof-title"></div>-->
                  <!--                        </div>-->
                  <!--                      </div>-->
                  <!--                      <div class="line"></div>-->
                  <!--                      <div class="date">-->
                  <!--                        <div class="date-block">-->
                  <!--                          &lt;!&ndash;                        <img loading="lazy" src="@/assets/timeslot-images/calendar1.svg" alt="">&ndash;&gt;-->
                  <!--                          <div class="date-tect"></div>-->
                  <!--                        </div>-->
                  <!--                        <div class="time-block">-->
                  <!--                          &lt;!&ndash;                        <img loading="lazy" src="@/assets/timeslot-images/clock1.svg" alt="">&ndash;&gt;-->
                  <!--                          <div class="time-range"></div>-->
                  <!--                        </div>-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <BaseComponentLoader
                    v-if="loader.nonBlockingLoader"
                    loaderAlignment="center"
                  />
                </div>
                <div
                  class="class-card-block"
                  v-else-if="
                    !loader.nonBlockingLoader && groupSessions.length > 0
                  "
                >
                  <div
                    class="w-layout-grid class-card"
                    @click="goToClassDetails(groupSession.groupSessionId)"
                    v-for="(groupSession, index) in groupSessions"
                    :key="index"
                  >
                    <div
                      id="w-node-_9ade9d8b-dee7-65d3-7682-169b0d1f7ae5-8f09cdd5"
                      class="card-image-block"
                    >
                      <div class="blue-block">
                        <div class="text-block-112">
                          {{ groupSession.professionalName }}
                        </div>
                        <div class="card-header-class">
                          {{ groupSession.groupSessionTopic }}
                        </div>
                      </div>
                    </div>
                    <div
                      id="w-node-_9ade9d8b-dee7-65d3-7682-169b0d1f7aeb-8f09cdd5"
                      class="content"
                    >
                      <div class="card-content-header">
                        <div class="date-block" style="padding-right:0;">
                          <!--                          <div class="class_title">-->
                          <!--                            {{ groupSession.groupSessionTopic }}-->
                          <!--                          </div>-->
                        </div>
                        <div
                          class="div-block-247"
                          style="display:flex; justify-content: flex-start;"
                        >
                          <div class="attendance_count">
                            {{ groupSession.groupSessionCurrentAttendees }}/{{
                              groupSession.groupSessionMaxAttendance
                            }}
                            Learners
                          </div>
                        </div>
                      </div>
                      <div class="prof-content">
                        <div class="prof-image-block">
                          <img
                            width="55"
                            height="55"
                            style="border-radius:50%;"
                            loading="lazy"
                            :src="groupSession.professionalDisplayPicture"
                            alt=""
                          />
                        </div>
                        <div>
                          <div class="prof-name">
                            {{ groupSession.professionalName }}
                          </div>
                          <div class="prof-title">
                            {{ groupSession.professionalCategory }}
                          </div>
                        </div>
                      </div>
                      <div class="line"></div>

                      <div class="date">
                        <div class="date-block">
                          <img
                            loading="lazy"
                            src="@/assets/timeslot-images/calendar1.svg"
                            alt=""
                          />
                          <div class="date-tect">
                            {{
                              new Date(
                                groupSession.groupSessionStartTime.slice(0, 10)
                              )
                                .toString()
                                .slice(0, 11)
                            }}
                          </div>
                        </div>
                        <div class="time-block">
                          <img
                            loading="lazy"
                            src="@/assets/timeslot-images/clock1.svg"
                            alt=""
                          />
                          <div class="time-range">
                            {{
                              formatHours(
                                new Date(groupSession.groupSessionStartTime)
                              )
                            }}:{{
                              formatMinutes(
                                new Date(groupSession.groupSessionStartTime)
                              )
                            }}
                            {{
                              formatTime(
                                new Date(groupSession.groupSessionStartTime)
                              )
                            }}
                            -
                            {{
                              formatHours(
                                new Date(groupSession.groupSessionEndTime)
                              )
                            }}:{{
                              formatMinutes(
                                new Date(groupSession.groupSessionEndTime)
                              )
                            }}
                            {{
                              formatTime(
                                new Date(groupSession.groupSessionEndTime)
                              )
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="div-block-19" style="margin-top: 70px;">
                    <img
                      src="@/assets/timeslot-images/myclass.svg"
                      loading="lazy"
                      alt=""
                      class="image-6"
                    />
                    <div class="text-block-20">Nothing to show here</div>
                    <div class="text-block-21">
                      There are no upcoming classes
                    </div>
                  </div>
                </div>

                <div
                  class="div-block-60"
                  v-if="showMore && !loader.nonBlockingLoader"
                  @click="moreClasses"
                >
                  <a href="#" class="button-13 w-button">Load more Classes</a>
                </div>
              </div>
            </div>
          </div>
          <!--        <div class="div-block-60">-->
          <!--          <a href="#" class="button-13 w-button">Load more Professionals</a>-->
          <!--        </div>-->
          <!--          <div class="class-card-block">-->
          <!--            <div-->
          <!--              class="w-layout-grid class-card "-->
          <!--              @click="goToClassDetails(groupSession.groupSessionId)"-->
          <!--              v-for="(groupSession, index) in groupSessions"-->
          <!--              :key="index"-->
          <!--            >-->
          <!--              <div-->
          <!--                id="w-node-_9ade9d8b-dee7-65d3-7682-169b0d1f7ae5-8f09cdd5"-->
          <!--                class="card-image-block"-->
          <!--              >-->
          <!--                <div>-->
          <!--                  <div class="text-block-112">-->
          <!--                    {{ groupSession.professionalName }}-->
          <!--                  </div>-->
          <!--                  <div class="card-header-class">-->
          <!--                    {{ groupSession.groupSessionTopic }}-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--              <div-->
          <!--                id="w-node-_9ade9d8b-dee7-65d3-7682-169b0d1f7aeb-8f09cdd5"-->
          <!--                class="content"-->
          <!--              >-->
          <!--                <div class="card-content-header">-->
          <!--                  <div class="date-block" style="padding-right:0;">-->
          <!--                    <div class="class_title">-->
          <!--                      {{ groupSession.groupSessionTopic }}-->
          <!--                    </div>-->
          <!--                  </div>-->
          <!--                  <div class="div-block-247">-->
          <!--                    <div class="attendance_count">-->
          <!--                      {{ groupSession.groupSessionCurrentAttendees }}/{{-->
          <!--                        groupSession.groupSessionMaxAttendance-->
          <!--                      }}-->
          <!--                      Learners-->
          <!--                    </div>-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--                <div class="prof-content">-->
          <!--                  <div class="prof-image-block">-->
          <!--                    <img-->
          <!--                      width="55"-->
          <!--                      loading="lazy"-->
          <!--                      :src="groupSession.professionalDisplayPicture"-->
          <!--                      alt=""-->
          <!--                    />-->
          <!--                  </div>-->

          <!--                  <div>-->
          <!--                    <div class="prof-name">-->
          <!--                      {{ groupSession.professionalName }}-->
          <!--                    </div>-->
          <!--                    <div class="prof-title">-->
          <!--                      {{ groupSession.professionalCategory }}-->
          <!--                    </div>-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--                <div class="line"></div>-->
          <!--                <div class="date">-->
          <!--                  <div class="date-block">-->
          <!--                    <img-->
          <!--                      loading="lazy"-->
          <!--                      src="@/assets/timeslot-images/calendar1.svg"-->
          <!--                      alt=""-->
          <!--                    />-->
          <!--                    <div class="date-tect">-->
          <!--                      {{-->
          <!--                        new Date(-->
          <!--                          groupSession.groupSessionStartTime.slice(0, 10)-->
          <!--                        )-->
          <!--                          .toString()-->
          <!--                          .slice(0, 11)-->
          <!--                      }}-->
          <!--                    </div>-->
          <!--                  </div>-->
          <!--                  <div class="time-block">-->
          <!--                    <img-->
          <!--                      loading="lazy"-->
          <!--                      src="@/assets/timeslot-images/clock1.svg"-->
          <!--                      alt=""-->
          <!--                    />-->
          <!--                    <div class="time-range">-->
          <!--                      {{-->
          <!--                        formatHours(-->
          <!--                          new Date(groupSession.groupSessionStartTime)-->
          <!--                        )-->
          <!--                      }}:{{-->
          <!--                        formatMinutes(-->
          <!--                          new Date(groupSession.groupSessionStartTime)-->
          <!--                        )-->
          <!--                      }}-->
          <!--                      {{-->
          <!--                        formatTime(new Date(groupSession.groupSessionStartTime))-->
          <!--                      }}-->
          <!--                      - -->
          <!--                      {{-->
          <!--                        formatHours(new Date(groupSession.groupSessionEndTime))-->
          <!--                      }}:{{-->
          <!--                        formatMinutes(-->
          <!--                          new Date(groupSession.groupSessionEndTime)-->
          <!--                        )-->
          <!--                      }}-->
          <!--                      {{-->
          <!--                        formatTime(new Date(groupSession.groupSessionEndTime))-->
          <!--                      }}-->
          <!--                    </div>-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>
    </div>
  </WebsiteLayout>
</template>

<script>
import WebsiteLayout from "@/components/layout/WebsiteLayout";
// import BaseComponentLoader from "@/components/BaseComponents/BaseComponentLoader";
import ProfessionalRequest from "@/model/requests/ProfessionalRequest";
import { mapState } from "vuex";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import { countryCodes } from "@/utils/country/countryCodes";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import moment from "moment";
import GroupSessionRequest from "@/model/requests/GroupSessionRequest";
import BaseComponentLoader from "@/components/BaseComponents/BaseComponentLoader";

export default {
  name: "NewDiscover",
  components: {
    BaseComponentLoader,
    WebsiteLayout
    // BaseComponentLoader
  },
  data() {
    return {
      isProfessionalsOpen: true,
      isClassesOpen: false,
      bar: true,
      cross: false,
      expertise: false,
      level: false,
      country: false,
      searchValue: "",
      professionalExpertise: "",
      professionalLevel: "",
      professionalCountry: "",
      searchModel: ProfessionalRequest.search,
      fetchClassesModel: GroupSessionRequest.readAllGroupSessions,
      searchItem: null,
      showMoreProfValue: true,
      showMoreClassValue: true,
      listForLoader: [0, 1, 2, 3, 4, 5, 6, 7]
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      professionalId: state => state.professional.professionalId,
      professionalList: state => state.professional.professionals,
      professionalDiscover: state => state.professional.professionalsDisplay,
      groupSessions: state => state.groupSession.groupSessions,
      categories() {
        return StoreUtils.rootGetters(
          StoreUtils.getters.professional.GET_CATEGORIES
        );
      },
      categoryList() {
        return Object.keys(this.categories);
      },
      experienceLevels() {
        return StoreUtils.rootGetters(
          StoreUtils.getters.professional.GET_EXPERIENCE_LEVELS
        );
      },
      countries() {
        return countryCodes.map(data => {
          return { label: data.name, value: data.name };
        });
      },
      loader: state => state.loader,
      showMore() {
        if (
          this.fetchClassesModel.page * 8 <=
          this.professionalDiscover.length
        ) {
          return (this.showMoreClassValue = false);
        } else {
          this.showMoreClassValue = true;
        }
      }
      // showMore(){
      //   let show = true;
      //   let currentTotal = this.professionalDiscover.length;
      //   let previousTotal = (this.searchModel.page - 1) * 8;
      //   let properTotal = (this.searchModel.page) * 8;
      //   if(currentTotal >= previousTotal && currentTotal <= properTotal){
      //      return show = true;
      //   }
      //   else{
      //     return show = false;
      //   }
      // }
    })
  },
  methods: {
    openProfessionals() {
      this.isProfessionalsOpen = true;
      this.isClassesOpen = false;
    },
    openClassesDiscover() {
      this.isProfessionalsOpen = false;
      this.isClassesOpen = true;
    },
    goToProfile() {
      RouterUtils.changeRouteUrlTo(`/professionals/${this.professionalId}`);
    },
    logout() {
      StoreUtils.dispatch(StoreUtils.actions.auth.LOGOUT);
    },
    showNav() {
      this.cross = true;
      this.bar = false;
    },
    closeNav() {
      this.bar = true;
      this.cross = false;
    },
    toggleExpertise() {
      this.expertise = !this.expertise;
    },
    toggleLevel() {
      this.level = !this.level;
    },
    toggleCountry() {
      this.country = !this.country;
    },
    profile(professional) {
      StoreUtils.commit(
        StoreUtils.mutations.professional.SET_PROFESSIONAL,
        professional
      );
      StoreUtils.commit(
        "professional/updateProfessionalId",
        professional.professionalId
      );
      RouterUtils.changeRouteUrlTo(
        `/professionals/${professional.professionalId}`
      );
    },

    searchProfessionalAction() {
      StoreUtils.dispatch("professional/searchProfessional", this.searchModel);
    },
    // || (this.professionalDiscover.length % 8 <= 8)
    moreProfessionals() {
      this.searchModel.page = this.searchModel.page + 1;
      StoreUtils.dispatch("professional/searchProfessional", this.searchModel);
    },
    formattedDate(date) {
      return moment(date).format("LT");
    },
    formatDate(date) {
      return moment(date).format("ll");
    },
    formatTime(date) {
      return moment(date).format("a");
    },
    formatMinutes(date) {
      return moment(date).format("mm");
    },
    formatHours(date) {
      return moment(date).format("h");
    },
    goToClassDetails(value) {
      RouterUtils.changeRouteUrlTo(`/class-details/${value}`);
    },
    moreClasses() {
      this.fetchClassesModel.page = this.fetchClassesModel.page + 1;
      StoreUtils.dispatch(
        "groupSession/readAllGroupSessions",
        this.fetchClassesModel
      );
    }
  },
  watch: {
    "searchModel.page"(newValue, oldValue) {
      if (
        newValue * 8 <= this.professionalDiscover.length ||
        oldValue * 8 <= this.professionalDiscover.length
      ) {
        return false;
      } else {
        return true;
      }
    }
  },
  mounted() {
    StoreUtils.dispatch(StoreUtils.actions.professional.READ_PROFESSIONALS);
    StoreUtils.dispatch(StoreUtils.actions.professional.FETCH_CATEGORIES);
    StoreUtils.dispatch(
      StoreUtils.actions.professional.FETCH_EXPERIENCE_LEVELS
    );
    StoreUtils.dispatch("groupSession/readAllGroupSessions");
  }
};
</script>

<style scoped>
.skeleton-load {
  animation: skeleton-loading 1s linear infinite alternate;
  border-color: rgba(3, 28, 67, 0.1);
  border-radius: 8px;
  height: 40px;
  color: #031c43;
}

@keyframes skeleton-loading {
  0% {
    background-color: hsl(200, 20%, 93%);
  }
  100% {
    background-color: hsl(200, 20%, 98%);
  }
}
.s-width {
  width: 20%;
}
.prof-empty {
  text-align: center;
  margin-top: 50px;
}
.ejzqWn {
  width: 100%;
  height: 269px;
  display: block;
  overflow: hidden;
  position: relative;
  border-radius: 16px;
  text-decoration: none;
  border: 0.5px solid rgba(105, 105, 105, 0.6);
  cursor: pointer;
}
.ejzqWn:hover,
.ejzqWn:active {
  transform: scale(0.99);
}
.ejzqWn .overlay {
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  padding: 20px 24px;
  position: absolute;
  flex-direction: column;
  transition: all 0.25s ease 0s;
  background-image: linear-gradient(transparent 0%, rgba(0, 0, 0, 0.5));
}
.ejzqWn .top-items {
  display: grid;
  grid-auto-flow: column;
  gap: 6px;
}
.ejzqWn .top-items .favorited {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
}
.dwCcQI .favorited,
.dwCcQI .details__items .item:nth-child(2) {
  display: none !important;
}
.ejzqWn .details {
  margin-top: auto;
  color: rgb(255, 255, 255);
}

.ejzqWn .details p {
  margin-bottom: 0px;
}
.ejzqWn .details__name {
  font-weight: 700;
  line-height: 18px;
}

.ejzqWn .details__items {
  /*margin-top: 10px;*/
}

.ejzqWn .details__items .item:first-child {
  margin-top: 0px;
}
.ejzqWn .details__items .item {
  display: flex;
  font-size: 14px;
  margin-top: 4px;
  line-height: 1.6;
}
.blue-block {
  padding: 0 20px;
}
@media only screen and (max-width: 991px) {
  .s-width {
    width: 50%;
  }
  .div-block-58 {
    gap: 10px;
  }
  .blue-block {
    padding: 0;
  }
}
</style>
